import React from "react";

const Footer = () => {
    return (
        <>
            <div className="bg-success text-center w-100 ">
                <div className="col-10 float-left m-3">
                    <div className="row">
                        <div className="col">
                            <h4 class="mb">We are more than just a School</h4>
                            <p class="medium  mb-0">We are Orgnization where we teach the descipline and CiVilization and Culture of our sociaty
                                The most important day of a person’s education is the first day of school, not Graduation Day.
                            </p>
                        </div>

                        <div className="col">
                            <br></br>
                            <ul>
                                <ol>Govind Chak</ol>
                                <ol>Sonpur ,Saran,Bihar</ol>
                                <ol>Pin:- 841101</ol>
                                <ol>Mobile No:- 7070806712,6204887570</ol>
                                <ol>Email:- modernconventandcoaching@gmail.com
                                </ol>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};
export default Footer;